export const hasStringId = (subject: unknown): subject is { id: string } => {
  if (subject && typeof subject === `object`) {
    const record = subject as Record<string, unknown>
    return typeof record.id === `string`
  }

  return false
}
